import { SearchOutlined } from '@teko/ds-icon';
import { Flex, styled } from '@teko/ds-mobile';
import { getTrackingData } from '@teko/tracking';
import { SearchBox } from 'components/mobile/organisms';
import { t } from 'i18n';
import { SlotComponentProps } from 'modules/page-builder/types';
import { useRouter } from 'next/router';
import { useTenantConfig } from 'hooks';

export type HeaderSearchProps = SlotComponentProps<{}>;

const StyledSearchOutlined = styled(SearchOutlined)`
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
`;

const OldLayoutHeaderSearchMobile: React.FC<HeaderSearchProps> = ({}) => {
  const router = useRouter();
  return (
    <Wrapper
      justify="center"
      align="center"
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'searchBox',
        target: 'searchProduct',
        payload: JSON.stringify({
          searchKeyword: '',
          ...(typeof window !== 'undefined'
            ? { href: window.location.href, url: window.location.href }
            : {}),
        }),
      })}
    >
      <StyledSearchOutlined size={24} />
      <SearchBox
        onClick={() => router.push('/search')}
        placeholder={t('Bạn muốn mua gì hôm nay...')}
      />
    </Wrapper>
  );
};

const NewLayoutHeaderSearchMobile: React.FC<HeaderSearchProps> = ({}) => {
  const router = useRouter();
  return (
    <NewLayoutWrapper
      justify="center"
      align="center"
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'searchBox',
        target: 'searchProduct',
        payload: JSON.stringify({
          searchKeyword: '',
          ...(typeof window !== 'undefined'
            ? { href: window.location.href, url: window.location.href }
            : {}),
        }),
      })}
    >
      <NewLayoutSearchBox
        onClick={() => router.push('/search')}
        placeholder={t('Bạn muốn mua gì hôm nay...')}
      />
      <SearchIconWrapper
        backgroundColor="primary"
        align="center"
        justify="center"
      >
        <SearchOutlined size={28} color="white" />
      </SearchIconWrapper>
    </NewLayoutWrapper>
  );
};

export const HeaderSearchMobile: React.FC<HeaderSearchProps> = ({}) => {
  const { displayNewLayout } = useTenantConfig();
  return displayNewLayout ? (
    <NewLayoutHeaderSearchMobile />
  ) : (
    <OldLayoutHeaderSearchMobile />
  );
};

const Wrapper = styled(Flex)`
  width: 100%;
  position: relative;
`;

const NewLayoutWrapper = styled(Flex)`
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  border-radius: calc(infinity * 1px);
`;

const SearchIconWrapper = styled(Flex)`
  width: 2.25rem;
  height: 32px;
  margin: 2px;
  border-radius: calc(infinity * 1px);
`;

const NewLayoutSearchBox = styled.input`
  width: 100%;
  height: 2.25rem;
  background-color: #f6f6f6;
  outline: none;
  border: none;
  border-radius: calc(infinity * 1px);\
  padding-left: 0.75rem;
`;
